import axios from './axios'
import {SET_ROLL_CALL,SET_ROLL_CALL_LOADING,GET_ERRORS,UPDATE_NEW_ROLL_CALL,UPDATE_CURRENT_ROLL_CALL} from './types'

export const getRollCall = (data) => dispatch => {
  dispatch(setRollCallLoading());
  axios
    .get(`/api/rollcall/list/?page=${data.page}&limit=${data.limit}`)
    .then(res =>
      dispatch({
        type: SET_ROLL_CALL,
        payload: res.data
      })
    )
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};

export const createNewRoll =(data) => dispatch => {
  dispatch(setRollCallLoading());
  axios.post('/api/rollcall/create',data).then(
    res=>dispatch({
      type: UPDATE_NEW_ROLL_CALL,
      payload: res.data
    })
  ).catch(err =>
    dispatch({
      type: GET_ERRORS,
      payload: err.response.data
    })
  );
}

export const getQRCode = (rid) => dispatch => {
  dispatch(setRollCallLoading());
  axios.get(`/api/rollcall/qrcode/?rid=${rid}`)
    .then(result => dispatch({
      type:UPDATE_CURRENT_ROLL_CALL,
      payload:result.data
    }))
}

export const closeQRCode = (rid) => dispatch => {
  axios.get(`/api/rollcall/closeqrcode/?rid=${rid}`)
    .then(result => dispatch({
      type:UPDATE_CURRENT_ROLL_CALL,
      payload:result.data
    }))
}

export const setRollCallLoading = () => {
  return {
    type: SET_ROLL_CALL_LOADING
  };
};


// WEBPACK FOOTER //
// ./src/actions/rollActions.js